import { Component, EventEmitter, Output } from "@angular/core";

import { AttachmentViewerComponent } from "../attachmentViewer";

/**
 * This is a barely modified copy of AttachmentViewerComponent...
 * This is only used once in library/contact. This should either be moved there, or this and AttachmentViewerComponent
 * should be merged into a single component
 *
 * @deprecated
 */
@Component({
    selector: "attachment-list",
    templateUrl: "./attachmentList.tmpl.html",
    standalone: false
})
export class AttachmentListComponent
    extends AttachmentViewerComponent
{
    @Output() readonly close = new EventEmitter<void>();

    override get saveLabel(): string { return "Done"; }
    override get closeLabel(): string { return "Cancel"; }

    override onClose(): void
    {
        this.close.emit();
    }
}
